import axios from 'axios';

export const API_URL = 'https://forms.tascombank.ua/api/v1/';

const $api = axios.create({
    baseURL: API_URL
});

export default $api;